module.exports = __webpack_public_path__ + "assets/lessons/en/lesson7/pages/lesson_7_2.pdf";